var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _c(
        "a-row",
        [
          _c(
            "a-row",
            { attrs: { gutter: 4 } },
            [
              _c("a-col", { attrs: { span: 10 } }, [
                _c("span", { staticClass: "list-header" }, [
                  _vm._v("抽检数量"),
                ]),
              ]),
              _c("a-col", { attrs: { span: 10 } }, [
                _c("span", { staticClass: "list-header" }, [
                  _vm._v("机构选择"),
                ]),
              ]),
              _c("a-col", { attrs: { span: 4 } }),
            ],
            1
          ),
          _vm._l(_vm.localValue, function (task, index) {
            return _c(
              "a-row",
              { key: index, style: { margin: "4px" }, attrs: { gutter: 4 } },
              [
                _c(
                  "a-col",
                  [
                    !_vm.disabled || task.execDept
                      ? _c(
                          "a-row",
                          [
                            _c(
                              "a-col",
                              { attrs: { span: 10 } },
                              _vm._l(
                                task.monitTaskRegionList,
                                function (itemItem) {
                                  return _c("a-input-number", {
                                    attrs: {
                                      size: "large",
                                      allowClear: "",
                                      placeholder: "请输入抽检数量",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeTask(task)
                                      },
                                    },
                                    model: {
                                      value: itemItem.pickCount,
                                      callback: function ($$v) {
                                        _vm.$set(itemItem, "pickCount", $$v)
                                      },
                                      expression: "itemItem.pickCount",
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                            _c(
                              "a-col",
                              { attrs: { span: 10 } },
                              [
                                _c("a-ext-gov-select", {
                                  attrs: { disabled: _vm.disabled },
                                  model: {
                                    value: task.execDept,
                                    callback: function ($$v) {
                                      _vm.$set(task, "execDept", $$v)
                                    },
                                    expression: "task.execDept",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "a-col",
                              { attrs: { span: 4 } },
                              [
                                index
                                  ? _c(
                                      "a-button",
                                      {
                                        attrs: { type: "link" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeItem(task)
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "a-row",
            { style: { margin: "4px" }, attrs: { gutter: 4 } },
            [
              _c(
                "a-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link", icon: "plus" },
                      on: { click: _vm.addItem },
                    },
                    [_vm._v(" 添加 ")]
                  ),
                ],
                1
              ),
              _c("a-col", { attrs: { span: 10 } }, [
                !_vm.disabled
                  ? _c("div", { staticClass: "total-box" }, [
                      _vm._v(" 总数量："),
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v(_vm._s(_vm.total)),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _c("a-col", { attrs: { span: 4 } }),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "big-title" }, [
      _c("span", [_vm._v("地区及机构")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }